import { call, delay, put, select, takeEvery } from "redux-saga/effects";
import * as offersActions from "../actions/offers";

import { getAllOffers } from "../../api/offers";
import { errorProcessing } from "../../../../Employees/api/errorProcessing";
import { dataAdjustmentErrorResponse } from "../../../../Employees/api/profileCard/dataAdjustment";
import showSuccessWindow from "../../../../../common/components/successPopup/successPopup";
import {
  successOfferCreation,
  successUpdateOffer
} from "../../../../Employees/components/ProfileCard/popup/success";
import history from "../../../../../common/history";
import { getCurrentRequest } from "../../api/offers/getCurrentRequest";
import { createOfferRequest } from "../../api/offerCreate/createOfferRequest";
import { updateOfferRequest } from "../../api/offerCard/updateOfferRequest";
import { getOffer } from "../../api/offerCard/getOffer";
import { createMonetizationTemplateRequest } from "../../api/offerCreate/createMonetizationTemplateRequest";
import { createOfferSuccess } from "../actions/offers";
import { getOffersCountsRequest } from "../../api/offers/getOffersCountsRequest";
import { message } from "antd";

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

function* getOfferSaga(action) {
  yield delay(1000);
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const { payload } = action;
      const response = yield call(getOffer, payload, activeProfileId);
      yield put(offersActions.getOfferSuccess(response));
    } catch (e) {
      yield put(offersActions.getOfferFailure(errorProcessing(e)));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(offersActions.getOffer())
      : history.push("/authorization/profiles");
  }
}

function* getOffersSaga({ payload }) {
  let activeProfileId = yield select(getActiveProfileId);

  if (activeProfileId) {
    try {
      const response = yield call(getAllOffers, activeProfileId, payload);
      const offerTypesResponse = yield call(
        getOffersCountsRequest,
        activeProfileId
      );
      let offerTypes = [];
      let obj = {};
      Object.keys(offerTypesResponse.data).forEach(key => {
        obj[key] = {
          key: key,
          count: offerTypesResponse.data[key],
          name:
            key === "total"
              ? "Все"
              : key === "assign"
              ? "Назначение ТС и Водителя"
              : key === "reserv"
              ? "Бронь"
              : key === "archive"
              ? "Архив"
              : null
        };
      });
      offerTypes = Object.keys(obj).map(key => ({
        key,
        count: obj[key].count,
        name: obj[key].name
      }));
      Object.keys(offerTypesResponse.data)
        .map(key =>
          offerTypesResponse.data[key] !== 0
            ? {
                key,
                count: offerTypesResponse.data[key],
                name:
                  key === "total"
                    ? "Все"
                    : key === "assign"
                    ? "Назначение ТС и Водителя"
                    : key === "reserv"
                    ? "Бронь"
                    : key === "archive"
                    ? "Архив"
                    : null
              }
            : false
        )
        .filter(item => item);
      let drivers = [];
      response.data.forEach(item => {
        // собираем всех водителей и исключаем дубликаты
        if (item.drivers && item.drivers.length > 0) {
          item.drivers.forEach(driver => {
            if (!drivers.some(item => item.id === driver.id)) {
              drivers.push(driver);
            }
          });
        }
      });

      yield put(
        offersActions.getOffersSuccess({
          offerTypes: Object.keys(offerTypes).map(key => offerTypes[key]),
          offers: response.data,
          pagination: response.pagination,
          drivers
        })
      );
    } catch (e) {
      yield put(offersActions.getOffersError(errorProcessing(e)));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(offersActions.getAllOffers())
      : history.push("/authorization/profiles");
  }
}

function* createOfferSaga(action) {
  try {
    const activeProfileId = yield select(getActiveProfileId);
    const { data, ymaps } = action.payload;

    const response = yield call(
      createOfferRequest,
      activeProfileId,
      data,
      ymaps
    );
    if (response) {
      if (data.monetizationTemplateNameCheck && data.monetizationTemplateName) {
        yield call(createMonetizationTemplateRequest, activeProfileId, data);
      }
      yield put(createOfferSuccess(response));
      showSuccessWindow(successOfferCreation(response.number));
      history.push("/executorship/offer");
    }
  } catch (e) {
    let errData = errorProcessing(e, dataAdjustmentErrorResponse);
    if (errData.message) {
      message.error(errData.message);
    }
    yield put(offersActions.createOfferFailure(errData));
  }
}

function* currentRequestSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getCurrentRequest, payload);
    yield put(offersActions.currentRequestSuccess(response));
  } catch (e) {
    yield put(offersActions.currentRequestFailure(e));
  }
}

function* updateOfferSaga(action) {
  let activeProfile = yield select(getActiveProfileId);
  const { data, ymaps } = action.payload;

  if (activeProfile) {
    try {
      const response = yield call(
        updateOfferRequest,
        activeProfile,
        data,
        ymaps
      );
      if (response) {
        if (data.monetizationTemplateNameCheck) {
          yield call(createMonetizationTemplateRequest, activeProfile, data);
        }
        yield put(offersActions.updateOfferSuccess(response));
        showSuccessWindow(
          successUpdateOffer(response.number, response.requestName)
        );
      }
    } catch (e) {
      let errData = errorProcessing(e, dataAdjustmentErrorResponse);
      if (errData.message) {
        message.error(e.message);
      }
      yield put(offersActions.updateOfferError(errData));
    }
  } else {
    history.push("/authorization/profiles");
  }
}

export function* offersConfigWatcher() {
  yield takeEvery(offersActions.getAllOffers.toString(), getOffersSaga);
  yield takeEvery(offersActions.getOffer.toString(), getOfferSaga);
  yield takeEvery(offersActions.createOffer.toString(), createOfferSaga);
  yield takeEvery(offersActions.currentRequest.toString(), currentRequestSaga);
  // yield takeEvery(
  //   offersActions.getFilterOffers.toString(),
  //   getFilterOffersSaga
  // );
  yield takeEvery(offersActions.updateOffer.toString(), updateOfferSaga);
}
